import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/form')({
  staticData: { breadcrumb: 'Forms', breadcrumbKey: 'K_BREADCRUMB_FORMS' },
});
